import { Search } from 'lucide-react';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Buscar logs...',
}) => {
  return (
    <div className="position-relative w-100">
      <Search
        className="position-absolute"
        size={20}
        style={{
          left: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#999',
        }}
      />
      <input
        type="text"
        className="form-control form-control-solid ps-12"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ height: '42px' }}
      />
    </div>
  );
};

export default SearchInput;
